// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

document.addEventListener("cart:item-added", function (evt) {});
document.addEventListener("cart:updated", function (evt) {});
document.addEventListener("cart:error", function (evt) {});
document.addEventListener("quick-cart:open", function (evt) {});
document.addEventListener("quick-cart:close", function () {});

function formatMoney$1(cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
  }
  return formatString.replace(placeholderRegex, value);
}

var formatMoney = (val => formatMoney$1(val, window.theme.moneyFormat || "${{amount}}"));

document.addEventListener("product:variant-change", function (evt) {
  document.querySelector(".c_price").innerHTML = formatMoney(evt.detail.variant.price);
});

document.addEventListener("product:quantity-update", function (evt) {});
document.addEventListener("quickview:loaded", function () {});


// ============================================
// HELPER: Always fetch fresh cart count
// ============================================
function awakeUpdateCartCount() {
  fetch('/cart.js', { cache: 'no-store' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('[data-js-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function() {});
}


// ============================================
// Widget Prompt + Free Shipping Bar
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('template-product')) return;

  var templateSuffix = document.body.getAttribute('tt');
  var isHairCare  = templateSuffix === 'hair-care';
  var isDeodorant = templateSuffix === 'deodrants';
  var isSkinCare  = templateSuffix === 'skin-care';
  var isSimpleHair = templateSuffix === 'simplehairbundle';
  var THRESHOLD   = 7000;

  // Bundle prompt switches - set to false to hide without deleting
  var SHOW_HAIR_PROMPT = true;
  var SHOW_SKIN_PROMPT = false;  // OFF - skincare offer under review, Oct 2026
  var SHOW_DEO_PROMPT  = true;
  var SHOW_SIMPLE_HAIR_PROMPT = true;

  function getActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'GBP';
  }

  function isUK() { return getActiveCurrency() === 'GBP'; }

  function fmt(cents, currency) {
    var curr = currency || getActiveCurrency();
    var localeMap = {
      'USD':'en-US','GBP':'en-GB','EUR':'de-DE','CAD':'en-CA','AUD':'en-AU',
      'NZD':'en-NZ','CHF':'de-CH','JPY':'ja-JP','SEK':'sv-SE','NOK':'nb-NO',
      'DKK':'da-DK','SGD':'en-SG','HKD':'en-HK','AED':'ar-AE','INR':'en-IN'
    };
    return new Intl.NumberFormat(localeMap[curr] || 'en-GB', {
      style: 'currency', currency: curr, minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function fetchBundlePrice(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variant = product.variants[0];
        return { price: variant.price, compareAt: variant.compare_at_price };
      });
  }

  function populatePricing(priceId, wasId, savingId, price, compareAt) {
    var currency = getActiveCurrency();
    document.getElementById(priceId).textContent = fmt(price, currency);
    if (compareAt && compareAt > price) {
      var saving = compareAt - price;
      document.getElementById(wasId).textContent = fmt(compareAt, currency);
      var savingEl = document.getElementById(savingId);
      savingEl.textContent = 'Save ' + fmt(saving, currency);
      savingEl.style.display = '';
    } else {
      document.getElementById(wasId).style.display = 'none';
      document.getElementById(savingId).style.display = 'none';
    }
  }

  var style = document.createElement('style');
  style.textContent = `
    #awake-bundle-prompt-standalone { margin-top:16px; margin-bottom:12px; display:flex !important; flex-direction:column; gap:0; visibility:visible !important; opacity:1 !important; }
    #awake-bundle-prompt-standalone * { visibility:visible !important; }
    #awake-bundle-wrapper { margin-top:0; margin-bottom:16px; display:flex; flex-direction:column; gap:0; }
    #awake-bundle-prompt { display:flex; flex-direction:column; gap:0; margin-bottom:12px; }
    .awake-bundle-box { border:1.5px solid #2c4a2e; border-radius:3px; padding:16px 18px; background:#f2f7f2; display:flex; flex-direction:column; gap:10px; }
    .awake-bundle-eyebrow { font-size:10px; letter-spacing:0.13em; text-transform:uppercase; color:#2c4a2e; font-weight:500; }
    .awake-bundle-name { font-size:17px; color:#1a1a18; line-height:1.3; font-weight:600; }
    .awake-bundle-chips { display:grid; grid-template-columns:repeat(2,auto); justify-content:start; gap:6px; }
    .awake-bundle-chip { font-size:11px; padding:3px 9px; border-radius:20px; background:#fff; border:1px solid #c8d4c9; color:#2c4a2e; font-weight:500; display:flex; align-items:center; gap:4px; }
    .awake-bundle-price-row { display:flex; align-items:center; gap:10px; }
    .awake-bundle-price { font-size:22px; font-weight:700; color:#1a1a18; }
    .awake-bundle-was { font-size:13px; color:#9a9585; text-decoration:line-through; }
    .awake-bundle-saving { font-size:11px; font-weight:500; background:#2c4a2e; color:#fff; padding:2px 8px; border-radius:2px; letter-spacing:0.04em; }
    .awake-bundle-meta { font-size:11.5px; color:#5a7a5c; display:flex; align-items:center; gap:5px; }
    .awake-bundle-cta { display:flex; justify-content:center; align-items:center; gap:5px; width:100%; background:#2c4a2e; color:#fff; border:none; border-radius:3px; padding:12px 16px; font-size:13.5px; font-weight:500; cursor:pointer; letter-spacing:0.03em; text-align:center; text-decoration:none; }
    .awake-bundle-cta:hover { background:#3a5e3c; color:#fff; }
    .awake-bundle-cta-arrow { flex-shrink:0; }
    @media (max-width:500px) { .awake-bundle-cta-arrow { display:none; } }
    .awake-deo-box { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:14px 16px; border-radius:3px; background:#2c4a2e; border:1px solid #3d6340; text-decoration:none; }
    .awake-deo-box:hover { background:#3a5e3c; }
    .awake-deo-left { display:flex; flex-direction:column; gap:4px; }
    .awake-deo-scents { display:flex; gap:4px; margin-bottom:2px; }
    .awake-deo-scent-dot { width:8px; height:8px; border-radius:50%; opacity:0.85; }
    .awake-deo-title { font-size:18px; color:#f5f0e8; line-height:1.2; letter-spacing:0.01em; font-weight:600; }
    .awake-deo-sub { font-size:11px; color:#a8c4a0; font-weight:400; letter-spacing:0.02em; }
    .awake-deo-right { display:flex; flex-direction:column; align-items:flex-end; gap:2px; flex-shrink:0; }
    .awake-deo-price-new { font-size:26px; color:#f5f0e8; line-height:1; font-weight:700; }
    .awake-deo-price-old { font-size:11px; color:#7aaa7c; text-decoration:line-through; }
    .awake-deo-saving-pill { font-size:10px; font-weight:600; background:#c8d4a0; color:#1a2e1a; padding:2px 7px; border-radius:2px; letter-spacing:0.05em; margin-top:2px; }
    .awake-or-divider { display:flex; align-items:center; gap:0; font-size:11px; font-weight:700; color:#1a1a18; letter-spacing:0.08em; text-transform:uppercase; margin:14px 0; }
    .awake-or-divider::before,.awake-or-divider::after { content:''; flex:1; height:1px; background:#e8e3da; }
    #awake-shipping-bar { margin-top:0; }
    #awake-shipping-bar .free-shipping-bar { border-top:1px solid #e8e3da; padding-top:10px; margin-top:0; }
    .ws_up_sell_main_container { margin:0 !important; border:none !important; box-shadow:none !important; padding:0 !important; }
  `;
  document.head.appendChild(style);

  // Find a TRULY safe insertion point for the green prompt — somewhere
  // completely outside any Shopify app block. The buy-buttons block (the
  // "Add to Cart" button) is a theme block, not an app block, so it's
  // safe. We insert the green prompt RIGHT AFTER it.
  function findSafeAnchor() {
    var candidates = [
      '[data-product-form]',
      '.product-form',
      'product-form',
      '[data-shopify-block][data-block-type="buy_buttons"]',
      '.product-info-block--buy_buttons',
      'form[action*="/cart/add"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return null;
  }

  // STANDALONE green prompt — built INDEPENDENTLY of Webrex. This runs
  // even if the Webrex widget never loads / never appears in the DOM
  // (e.g. when all upsell products are already in the cart and Webrex
  // removes itself entirely).
  function buildStandalonePrompt() {
    if (isHairCare  && !SHOW_HAIR_PROMPT) return;
    if (isSkinCare  && !SHOW_SKIN_PROMPT) return;
    if (isDeodorant && !SHOW_DEO_PROMPT)  return;
    if (isSimpleHair && !SHOW_SIMPLE_HAIR_PROMPT) return;
    if (document.getElementById('awake-bundle-prompt-standalone')) return;
    var safeAnchor = findSafeAnchor();
    if (!safeAnchor) return; // can't anchor — bail; retry later
    var standalone = document.createElement('div');
    standalone.id = 'awake-bundle-prompt-standalone';
    if (safeAnchor.nextSibling) {
      safeAnchor.parentNode.insertBefore(standalone, safeAnchor.nextSibling);
    } else {
      safeAnchor.parentNode.appendChild(standalone);
    }

    var shippingMetaHTML = isUK()
      ? `<div class="awake-bundle-meta">
           <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M1 3h13v13H1V3z" stroke="#5a7a5c" stroke-width="1.6" stroke-linejoin="round"/>
             <path d="M14 8h4l3 4v4h-7V8z" stroke="#5a7a5c" stroke-width="1.6" stroke-linejoin="round"/>
             <circle cx="5.5" cy="17.5" r="1.5" stroke="#5a7a5c" stroke-width="1.4"/>
             <circle cx="18.5" cy="17.5" r="1.5" stroke="#5a7a5c" stroke-width="1.4"/>
           </svg>
           Free shipping included
         </div>` : '';

    if (isHairCare || isSimpleHair) {
      var hairPrompt = document.createElement('div');
      hairPrompt.id = 'awake-bundle-prompt';
      hairPrompt.innerHTML = `
        <div class="awake-bundle-box">
          <span class="awake-bundle-eyebrow">Want the full routine?</span>
          <div class="awake-bundle-name">Pro-Hair Growth Bundle</div>
          <div class="awake-bundle-chips">
            <span class="awake-bundle-chip"><span>✓</span> Shampoo</span>
            <span class="awake-bundle-chip"><span>✓</span> Conditioner</span>
            <span class="awake-bundle-chip"><span>✓</span> Super Oil</span>
            <span class="awake-bundle-chip"><span>✓</span> Scalp Scrub</span>
          </div>
          <div class="awake-bundle-price-row">
            <span class="awake-bundle-price" id="awake-hair-price">—</span>
            <span class="awake-bundle-was" id="awake-hair-was"></span>
            <span class="awake-bundle-saving" id="awake-hair-saving" style="display:none"></span>
          </div>
          ${shippingMetaHTML}
          <a href="https://awakeorganics.co.uk/collections/natural-hair-care-bundles/products/pro-hair-growth-bundle" class="awake-bundle-cta">
            <span>Try Our Pro-Hair Growth Bundle</span>
            <span class="awake-bundle-cta-arrow">→</span>
          </a>
        </div>`;
      standalone.appendChild(hairPrompt);
      fetchBundlePrice('pro-hair-growth-bundle')
        .then(function(p) { populatePricing('awake-hair-price','awake-hair-was','awake-hair-saving',p.price,p.compareAt); })
        .catch(function() {});
    } else if (isSkinCare) {
      var skinPrompt = document.createElement('div');
      skinPrompt.id = 'awake-bundle-prompt';
      skinPrompt.innerHTML = `
        <div class="awake-bundle-box">
          <span class="awake-bundle-eyebrow">Want the full routine?</span>
          <div class="awake-bundle-name">Natural Skincare Best Sellers</div>
          <div class="awake-bundle-chips">
            <span class="awake-bundle-chip"><span>✓</span> Brightening Serum</span>
            <span class="awake-bundle-chip"><span>✓</span> Moisture Balm</span>
            <span class="awake-bundle-chip"><span>✓</span> Cleansing Balm</span>
            <span class="awake-bundle-chip"><span>✓</span> Micro Polish</span>
          </div>
          <div class="awake-bundle-price-row">
            <span class="awake-bundle-price" id="awake-skin-price">—</span>
            <span class="awake-bundle-was" id="awake-skin-was"></span>
            <span class="awake-bundle-saving" id="awake-skin-saving" style="display:none"></span>
          </div>
          ${shippingMetaHTML}
          <a href="https://awakeorganics.co.uk/collections/natural-skin-care-bundles/products/natural-skincare-best-sellers" class="awake-bundle-cta">
            <span>Try Our Best-Sellers Bundle</span>
            <span class="awake-bundle-cta-arrow">→</span>
          </a>
        </div>`;
      standalone.appendChild(skinPrompt);
      fetchBundlePrice('natural-skincare-best-sellers')
        .then(function(p) { populatePricing('awake-skin-price','awake-skin-was','awake-skin-saving',p.price,p.compareAt); })
        .catch(function() {});
    } else if (isDeodorant) {
      var deoProm = document.createElement('div');
      deoProm.id = 'awake-bundle-prompt';
      deoProm.innerHTML = `
        <a href="https://awakeorganics.co.uk/collections/natural-deodorant-bundles/products/100-natural-deodorant-3-pack-you-pick-save-10" class="awake-deo-box">
          <div class="awake-deo-left">
            <div class="awake-deo-scents">
              <span class="awake-deo-scent-dot" style="background:#c8a882"></span>
              <span class="awake-deo-scent-dot" style="background:#8fada3"></span>
              <span class="awake-deo-scent-dot" style="background:#b5927a"></span>
            </div>
            <div class="awake-deo-title">Try 3 &amp; Save</div>
            <div class="awake-deo-sub">Mix &amp; Match Any 3 Natural Deodorants</div>
          </div>
          <div class="awake-deo-right">
            <div class="awake-deo-price-new" id="awake-deo-price">—</div>
            <div class="awake-deo-price-old" id="awake-deo-was" style="display:none"></div>
            <div class="awake-deo-saving-pill" id="awake-deo-saving" style="display:none"></div>
          </div>
        </a>`;
      standalone.appendChild(deoProm);
      fetchBundlePrice('100-natural-deodorant-3-pack-you-pick-save-10')
        .then(function(p) {
          var currency = getActiveCurrency();
          document.getElementById('awake-deo-price').textContent = fmt(p.price, currency);
          if (p.compareAt && p.compareAt > p.price) {
            var saving = p.compareAt - p.price;
            var wasEl = document.getElementById('awake-deo-was');
            wasEl.textContent = 'reg ' + fmt(p.compareAt, currency);
            wasEl.style.display = '';
            var saveEl = document.getElementById('awake-deo-saving');
            saveEl.textContent = 'Save ' + fmt(saving, currency);
            saveEl.style.display = '';
          }
        })
        .catch(function() {});
    }
  }

  // Webrex wrapper — runs only when the Webrex widget appears. Wraps the
  // widget with the "or build your own" divider above, and a shipping bar
  // appended below (added separately via renderBar). This wrapper does NOT
  // contain the green prompt — the green prompt lives separately.
  function buildWrapper(widget) {
    if (document.getElementById('awake-bundle-wrapper')) return;

    var wrapper = document.createElement('div');
    wrapper.id = 'awake-bundle-wrapper';
    widget.parentNode.insertBefore(wrapper, widget);

    // Divider goes INSIDE the wrapper, so it hides together with the
    // Webrex widget when all products are added. It also hides when the
    // prompt it introduces is switched off above.
    if ((isHairCare && SHOW_HAIR_PROMPT) || (isSkinCare && SHOW_SKIN_PROMPT) || (isDeodorant && SHOW_DEO_PROMPT) || (isSimpleHair && SHOW_SIMPLE_HAIR_PROMPT)) {
      var divider = document.createElement('div');
      divider.className = 'awake-or-divider';
      wrapper.appendChild(divider);
    }

    // Move the Webrex widget into the wrapper, AFTER the divider, so
    // the visual order is: [divider] [Webrex widget].
    wrapper.appendChild(widget);
  }

  function injectWebrexComparePrices(widget) {
    function processCard(card) {
      if (card.dataset.awakePriced) return;
      card.dataset.awakePriced = 'true';
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!match) return;
      var handle = match[1];
      var priceEl = card.querySelector('.ws_product_price, .ws-price, .ws_price, [class*="price"]:not([class*="compare"]):not([class*="was"])');
      if (!priceEl) return;
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var variant = product.variants[0];
          var price = variant.price;
          var compareAt = variant.compare_at_price;
          if (!compareAt || compareAt <= price) return;
          var currency = getActiveCurrency();
          priceEl.style.color = '#c0392b';
          priceEl.style.fontWeight = '700';
          var wasEl = document.createElement('span');
          wasEl.className = 'awake-webrex-was';
          wasEl.textContent = fmt(compareAt, currency);
          wasEl.style.cssText = 'display:block;font-size:11px;color:#9a9585;text-decoration:line-through;line-height:1.2;margin-bottom:1px';
          priceEl.parentNode.insertBefore(wasEl, priceEl);
          var saving = compareAt - price;
          var badgeEl = document.createElement('span');
          badgeEl.className = 'awake-webrex-save';
          badgeEl.textContent = 'Save ' + fmt(saving, currency);
          badgeEl.style.cssText = 'display:inline-block;font-size:10px;font-weight:600;background:#2c4a2e;color:#fff;padding:1px 6px;border-radius:2px;margin-top:3px;letter-spacing:0.03em';
          priceEl.parentNode.insertBefore(badgeEl, priceEl.nextSibling);
        })
        .catch(function() {});
    }
    widget.querySelectorAll('[class*="ws_"]').forEach(processCard);
    new MutationObserver(function() {
      widget.querySelectorAll('[class*="ws_"]').forEach(processCard);
    }).observe(widget, { childList: true, subtree: true });
  }

  function renderBar(cartTotal) {
    if (!isUK()) return;
    var existing = document.getElementById('awake-shipping-bar');
    if (existing) existing.remove();
    var wrapper = document.getElementById('awake-bundle-wrapper');
    if (!wrapper) return;
    var progress = Math.min(cartTotal / THRESHOLD, 1);
    var remaining = THRESHOLD - cartTotal;
    var isSuccess = cartTotal >= THRESHOLD;
    var message = isSuccess
      ? 'Your order qualifies for free shipping!'
      : 'Only <strong>£' + (remaining / 100).toFixed(2) + '</strong> away from Free Shipping!';
    var barWrapper = document.createElement('div');
    barWrapper.id = 'awake-shipping-bar';
    var bar = document.createElement('div');
    bar.className = 'free-shipping-bar free-shipping-bar--loaded' + (isSuccess ? ' free-shipping-bar--success' : '');
    bar.setAttribute('data-free-shipping-bar', '');
    bar.innerHTML = `
      <div class="inventory-counter__message-wrapper ff-body fs-body-75">
        <span class="icon icon-new icon-package-closed">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:1.25em;height:1.25em;">
            <path d="M22.48 5.28 12 8.813 1.518 5.28M12 21.851V8.814" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>
            <path d="m7.025 3.425 10.48 3.535" stroke="currentColor" stroke-width="1.079" stroke-miterlimit="10"></path>
            <path d="m12 21.851 10.48-4.413V5.279L12 1.75 1.518 5.279v12.159L12 21.85z" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path>
            <path d="m4.322 8.855 4.403 1.524v2.945L4.322 11.67V8.855z" stroke="currentColor" stroke-width="1.079" stroke-miterlimit="10"></path>
          </svg>
        </span>
        <h4 class="free-shipping-bar__message">${message}</h4>
      </div>
      ${!isSuccess ? `<div class="free-shipping-bar__bar"><span class="free-shipping-bar__bar-progress" style="--progress-width:${progress*100}%;width:${progress*100}%;"></span></div>` : ''}`;
    barWrapper.appendChild(bar);
    wrapper.appendChild(barWrapper);
  }

  function initAll() {
    // ALWAYS try to build the standalone green prompt first — it does
    // not need the Webrex widget to exist. This way, even if Webrex
    // never loads (e.g. all upsell products already in cart) the green
    // box still appears.
    buildStandalonePrompt();

    var widget = document.querySelector('.ws_up_sell_main_container');
    if (widget) {
      buildWrapper(widget);
      injectWebrexComparePrices(widget);
    }
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.currency !== 'GBP') return;
        renderBar(cart.total_price);
      });
  }



  // Build the standalone green prompt IMMEDIATELY — it does not depend on
  // Webrex existing. If the anchor (Add to Cart form) isn't ready yet,
  // retry briefly.
  (function ensureStandalonePrompt() {
    var tries = 0;
    function attempt() {
      buildStandalonePrompt();
      if (document.getElementById('awake-bundle-prompt-standalone')) return;
      tries++;
      if (tries < 15) setTimeout(attempt, 300);
    }
    attempt();
  })();

  // Also fetch the cart total so the shipping bar renders even if Webrex
  // doesn't appear. (The shipping bar attaches to #awake-bundle-wrapper
  // which only exists when Webrex loads — so this is mostly for keeping
  // the existing behaviour when Webrex IS present.)
  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    if (document.querySelector('.ws_up_sell_main_container')) {
      initAll();
      clearInterval(poll);
    }
    if (attempts >= 20) {
      // Webrex never appeared — make sure cart-driven shipping bar logic
      // still ran by triggering initAll once (it will skip the Webrex
      // parts gracefully).
      initAll();
      clearInterval(poll);
    }
  }, 500);

  document.addEventListener('cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) {
      if (evt.detail.cart.currency !== 'GBP') return;
      renderBar(evt.detail.cart.total_price);
    }
  });

});


// ============================================
// Show apps section heading only when loaded
// ============================================
(function() {
  function checkAppsSection() {
    document.querySelectorAll('[data-section-type="apps"]').forEach(function(section) {
      var heading = section.querySelector('.section-introduction');
      if (!heading) return;
      var items = section.querySelectorAll('.animation--item');
      var hasContent = false;
      items.forEach(function(item) {
        if (item.children.length > 0 && item.offsetHeight > 0) hasContent = true;
      });
      heading.style.display = hasContent ? '' : 'none';
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(checkAppsSection, 1500);
  });
  var appsObserver = new MutationObserver(checkAppsSection);
  document.querySelectorAll('[data-section-type="apps"]').forEach(function(section) {
    appsObserver.observe(section, { childList: true, subtree: true });
  });
})();


// ============================================
// Mobile: intercept cart icon BEFORE drawer opens
// Use location.replace so it doesn't pollute back-button history
// ============================================
document.addEventListener('click', function(e) {
  if (window.innerWidth >= 768) return;
  var cartTrigger = e.target.closest('a[href="/cart"], [data-open-cart], .header__icon--cart, [data-modal-open="quick-cart"]');
  if (cartTrigger) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.replace('/cart');
  }
}, true);


// ============================================
// Always fetch fresh cart count on every page load/show
// Covers: first load, back/forward cache, tab switching
// ============================================
document.addEventListener('DOMContentLoaded', awakeUpdateCartCount);
window.addEventListener('pageshow', awakeUpdateCartCount);
window.addEventListener('focus', awakeUpdateCartCount);
document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    awakeUpdateCartCount();
  }
});


// ============================================
// Update cart count after any add-to-cart action
// ============================================
document.addEventListener('click', function(e) {
  var addBtn = e.target.closest(
    '.ws_up_sell_main_container button, ' +
    '.product-preview-add-to-cart, ' +
    '[data-add-to-cart], ' +
    'button[name="add"]'
  );
  if (!addBtn) return;
  setTimeout(awakeUpdateCartCount, 800);
  setTimeout(awakeUpdateCartCount, 2000);
});

document.addEventListener('cart:item-added', awakeUpdateCartCount);
document.addEventListener('cart:updated', awakeUpdateCartCount);


// ============================================
// MOBILE CART FIX - Direct quantity update handler
// Bypasses theme's broken Delegate library on iOS Safari
// ============================================
(function() {
  if (window.location.pathname !== '/cart') return;

  var isProcessing = false;

  function handleQtyClick(e) {
    var btn = e.target.closest('[data-add-quantity], [data-subtract-quantity], [data-remove-item]');
    if (!btn) return;

    if (isProcessing) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var item = btn.closest('[data-input-item]');
    if (!item) return;

    var key = item.getAttribute('data-key');
    var input = item.querySelector('[data-quantity-input]');
    if (!key || !input) return;

    var currentQty = parseInt(input.value, 10) || 1;
    var newQty;

    if (btn.hasAttribute('data-remove-item')) {
      newQty = 0;
    } else if (btn.hasAttribute('data-add-quantity')) {
      newQty = currentQty + 1;
    } else {
      newQty = Math.max(currentQty - 1, 0);
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    isProcessing = true;
    btn.disabled = true;
    item.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: newQty }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      return fetch('/cart?section_id=' + document.querySelector('[data-section-type="cart"]').getAttribute('data-section-id'), {
        credentials: 'same-origin'
      })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var container = document.querySelector('[data-section-type="cart"]');
        if (container) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          container.innerHTML = temp.innerHTML;
        }
        document.querySelectorAll('[data-js-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
    })
    .catch(function(err) {
      console.error('Cart update failed:', err);
      item.style.opacity = '1';
      if (btn) btn.disabled = false;
    })
    .finally(function() {
      isProcessing = false;
    });
  }

  document.addEventListener('click', handleQtyClick, true);
  document.addEventListener('touchend', handleQtyClick, true);
})();

// ============================================
// After WS Pairs Well With Add, redirect to /cart fresh
// Listens for Shopify's cart events for instant response
// ============================================
(function() {
  var pendingWsAdd = false;

  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('.ws_up_sell_main_container button, .ws_up_sell_main_container a, .product-preview-add-to-cart');
    if (!addBtn) return;
    pendingWsAdd = true;

    // Safety: if no event fires within 2s, redirect anyway
    setTimeout(function() {
      if (pendingWsAdd) {
        pendingWsAdd = false;
        window.location.replace('/cart');
      }
    }, 2000);
  });

  document.addEventListener('cart:item-added', function() {
    if (pendingWsAdd) {
      pendingWsAdd = false;
      window.location.replace('/cart');
    }
  });

  document.addEventListener('cart:updated', function() {
    if (pendingWsAdd) {
      pendingWsAdd = false;
      window.location.replace('/cart');
    }
  });
})();